export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      communityUuid: "community002",
      communityNumber: "1002",
      communityName: "アイラ地域サポート",
      tenantName: 'テナント名',
      modelNumber: [
        "xxxxxx",
        "xxxxxx"
      ],
      note: "xxxxxx",
      status: 1,
      communityTantous: [
        "どい"
      ],
      locations: [
        {
          locationNumber: "xxxxxx",
          locationUuid: "locations001",
          deviceSerial: "xxxxxx",
          modelNumber: "xxxxxx",
          modelName: "xxxxxx",
          profile1: {
            profileOrder: 1,
            body: "xxxxxx",
          },
          status: 1
        }
      ]
    }
  }
}